/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import baseColors from '@salesforce/retail-react-app/app/theme/foundations/colors';

export default {
  ...baseColors,

  primary: baseColors.blue,
  secondary: baseColors.gray,
  success: baseColors.green,
  error: baseColors.red,
  warning: baseColors.orange,
  info: baseColors.cyan,
  light: baseColors.whiteAlpha,
  dark: baseColors.blackAlpha,
};
